<template>
    <BasePage>
        <SotHeader label="Профиль" @back="back" :hide-back-button="showButtonNext" />
        <div class="q-pa-md q-gutter-y-sm base-page-content">
            <TextInput ref="fio" label="ФИО" v-model="user.shownname" svg-icon="user" />
            <PhoneInput ref="tel" v-model="tel" />
            <q-select class="sot-select" borderless label="Регион" v-model="region" :debounce="400" :options="regionsFiltered" option-label="name_with_type" option-value="kladr_id" use-input @filter="filterRegions" popup-content-style="color: #323758">
                <template v-slot:selected>
                    <div v-if="region">
                        {{ region.name_with_type }}
                    </div>
                </template>
                <template v-slot:prepend>
                    <q-img src="~assets/ui/icons/map-pin.svg" width="26px" height="26px" />
                </template>
            </q-select>
            <TextInput label="Организация" v-model="user.school_number" svg-icon="book-open" />
            <TextInput label="Должность" v-model="user.position" svg-icon="briefcase" />
            <TextInput label="О себе" v-model="user.bio" icon="info_outline" autogrow />
            <TextInput v-show="false" label="Баланс" v-model="user.balance" icon="account_balance_wallet" read-only suffix="₽" />

            <q-select v-show="allowChannelSelect" class="sot-select" borderless label="Канал для связи" :options="['Телеграм', 'ВКонтакте']" v-model="chatChannel" style="padding-left: 23px; color: #85371F;" input-style="color: #85371F" />
            <div class="text-caption text-grey">
                {{ user.hashtags }}
            </div>
            <div v-show="telChanged && !codeSent" class="row q-gutter-y-sm">
                <DefaultButton class="col" label="Подтвердить номер" @click="confirmNum" :disabled="codeSent" />
                <div class="text-grey text-caption">На указанный номер будет отправлено СМС сообщение с кодом подтверждения</div>
            </div>
            <div v-show="codeSent" class="q-gutter-y-sm">
                <TextInput ref="code" label="Код подтверждения" v-model="codeInput" />
                <div class="text-grey text-caption">На указанный номер телефона отправлено СМС сообщение с кодом подтверждения</div>
                <div class="row">
                    <DefaultButton class="col" label="Сохранить номер телефона" @click="saveNum" :disabled="codeSent" />
                </div>
            </div>
        </div>
        <div class="q-gutter-y-sm q-pa-md" v-if="!showButtonNext">
            <!--
            <DefaultButton label="Пополнить баланс" @click="addToBalance" />
            <DefaultButton label="Списать с счета" @click="spendMoney" />
            -->
            <DefaultButton v-show="allowCert" label="Сертификат" @click="createCert" :loading="loading" />
            <DefaultButton v-show="allowLinkTg" label="Привязать аккаунт Телеграм" @click="linkTg" />
            <DefaultButton v-show="allowLinkVk" label="Привязать аккаунт ВКонтакте" @click="linkVk" />
            <DefaultButton v-show="allowLogout" label="Выйти из системы" @click="logout" />
        </div>
        <div class="q-gutter-y-sm q-pa-md" v-if="showButtonNext">
            <DefaultButton label="Далее" @click="next" :loading="nexting" />
        </div>
    </BasePage>
</template>

<script>
import axios from 'axios';
import PhoneInput from 'components/ui/PhoneInput';
import { sendSmsMessage, isTg } from 'boot/axios';
import SotHeader from 'components/ui/design/SotHeader';
import TextInput from 'components/ui/common/TextInput';
import DefaultButton from 'components/ui/common/DefaultButton';
import BasePage from 'pages/BasePage';

export default {
    name: 'PageBio',
    components: {
        BasePage,
        DefaultButton,
        TextInput,
        SotHeader,
        PhoneInput,
    },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    computed: {
        pureTel () {
            let { tel } = this;
            if (!tel) {
                return '';
            }
            tel = tel.replaceAll('+', '');
            tel = tel.replaceAll('(', '');
            tel = tel.replaceAll(')', '');
            tel = tel.replaceAll('-', '');
            tel = tel.replaceAll(' ', '');
            return tel;
        },
        allowCert () {
            const { hashtags } = this.user;
            if (hashtags && hashtags.includes('#сертификат')) {
                return true;
            }
            return false;
        },
        allowLinkTg () {
            const { hashtags } = this.user;
            if (hashtags && hashtags.includes('#kurs')) {
                return !isTg(this.user.chat_id);
            }
            return false;
        },
        allowLinkVk () {
            const { hashtags } = this.user;
            if (hashtags && hashtags.includes('#kurs')) {
                return !(+this.user.vk_id > 0);
            }
            return false;
        },
        allowLogout () {
            const { hashtags } = this.user;
            return !!(hashtags && hashtags.includes('#kurs'));
        },
        allowChannelSelect () {
            const { hashtags } = this.user;
            const hasVk = +this.user.vk_id > 0;
            const hasTg = isTg(this.user.chat_id);
            if (hashtags && hashtags.includes('#kurs')) {
                return hasVk && hasTg;
            }
            return false;
        },
        page () {
            return this.$store.state.pages.page;
        },
        showButtonNext () {
            if (!this.page) { return false; }
            if (!this.page.params) { return false; }
            return this.page.params.show_button_next;
        },
    },
    mounted () {
        this.codeSent = false;
        this.telChanged = false;
        const { user } = this.$store.state.pages;
        this.user = { ...user };
        // this.refreshBalance();

        const channel = this.user.chat_channel;
        if (!channel) {
            const hasTg = isTg(this.user.chat_id);
            const hasVk = +this.user.vk_id > 0;
            if (hasTg) {
                this.chatChannel = 'Телеграм';
            } else
            if (hasVk) {
                this.chatChannel = 'ВКонтакте';
            }
        } else {
            this.chatChannel = channel === 'vk' ? 'ВКонтакте' : 'Телеграм';
        }
        if (user && user.tel) {
            this.tel = user.tel;
        }
        this.loadRegions();
    },
    watch: {
        user: {
            deep: true,
            handler (v, old) {
                if (old === v) { return; }
                if (old.id) {
                    this.save(v);
                }
            },
        },
    },
    data () {
        return {
            user: {},
            tel: undefined,
            region: undefined,
            regions: [],
            regionsFiltered: [],
            codeSent: false,
            codeInput: undefined,
            code: undefined,
            telChanged: false,
            loading: false,
            chatChannel: undefined,
            nexting: false,
        };
    },
    methods: {
        save (user) {
            const { region } = this;
            if (region) {
                user.region_name = region.name_with_type;
                user.region_number = region.kladr_id;
            }
            user.tel = this.pureTel;

            if (this.chatChannel && this.chatChannel.toLowerCase() === 'телеграм') {
                user.chat_channel = 'tg';
            }
            if (this.chatChannel && this.chatChannel.toLowerCase() === 'вконтакте') {
                user.chat_channel = 'vk';
            }

            return this.$db.users.update(user).then(() => {
                this.$store.commit('pages/setUser', { ...user });
            });
        },
        logout () {
            localStorage.removeItem('key');
            this.$store.commit('pages/setUser', undefined);
            this.$pages.back();
        },
        loadRegions () {
            const url = 'consts/regions.json';
            axios.get(url).then((r) => {
                this.regions = r.data;
                this.regionsFiltered = [].concat(this.regions);

                this.region = undefined;
                if (this.user.region_number) {
                    this.regions.forEach((reg) => {
                        if (reg.kladr_id.toString() === this.user.region_number.toString()) {
                            this.region = { ...reg };
                        }
                    });
                }
            });
        },
        filterRegions (val, update) {
            val = val.toLowerCase();
            const filtered = this.regions.filter((r) => r.name_with_type.toLowerCase().includes(val));
            this.regionsFiltered = [].concat(filtered);
            update();
        },
        back (e) {
            if (!this.user.shownname) {
                this.$q.notify('Укажите ФИО');
                e.cancelBubble = true;
                return;
            }
            this.save(this.user);
        },
        saveNum () {
            if (!this.codeInput) {
                this.$refs.code.select();
                this.$q.notify('Введите код из СМС-сообщения');
                return;
            }
            if (+this.codeInput !== +this.code) {
                this.$refs.code.select();
                this.$q.notify('Неправильный код подтверждения');
                return;
            }
            this.save(this.user);
            this.$pages.back();
        },
        createCode () {
            this.$db.users.createCode(this.pureTel).then((code) => {
                this.code = code;
                sendSmsMessage(this.pureTel, `Ваш код: ${code}`);
                this.$nextTick(() => {
                    this.$refs.code.select();
                });
            });
        },
        confirmNum () {
            this.createCode();
            this.codeSent = true;
        },
        async createCert () {
            if (!this.user.shownname) {
                this.$q.notify('Укажите ФИО');
                return;
            }
            this.loading = true;
            await this.save(this.user);
            const url = `${window.location.origin}/api/generate_cert.php?id=${this.user.id}&key=70fa-e5C2`;

            axios.get(url).then((r) => {
                this.loading = false;
                if (r && r.data && r.data.pdf_url) {
                    window.open(r.data.pdf_url, '_blank');
                } else {
                    this.$q.notify('Ошибка создания сертификата');
                }
            });
        },
        linkTg () {
            const url = `https://t.me/Kurs1TBot?start=from_club=vk_id_${this.user.vk_id}`;
            window.open(url, '_blank');
        },
        linkVk () {
            const url = `${window.location.origin}/sot.bot/vk_app/api/auth.php?state=${this.user.chat_id}`;
            window.open(url, '_blank');
        },
        next () {
            if (!this.user.shownname) {
                this.$q.notify('Для продолжения заполните поле ввода "ФИО"');
                this.$refs.fio.select();
                return;
            }
            if (!this.tel) {
                this.$q.notify('Для продолжения заполните поле ввода "Мобильный телефон"');
                this.$refs.tel.select();
                return;
            }
            this.nexting = true;
            this.save(this.user).then(() => {
                this.nexting = false;
                window.location.reload();
            });
        },
        /*
        addToBalance () {
            const payload = {
                amount: 5,
                type: 100,
            };
            this.$billing.addToBalance(payload).then((newBalance) => {
                this.user.balance = newBalance;
                this.$q.notify('Баланс пополнен');
            }).catch((e) => {
                console.error(e);
            });
        },
        spendMoney () {
            const payload = {
                amount: 5,
                type: 200,
            };
            this.$billing.spend(payload).then((newBalance) => {
                this.user.balance = newBalance;
                this.$q.notify('Списание выполнено');
            }).catch((e) => {
                console.error(e);
            });
        },
        refreshBalance () {
            this.$billing.getBalance(this.user.id).then((r) => {
                this.user.balance = r.data[0].balance;
            });
        },
         */
    },
};
</script>

<style scoped>

</style>
